/** @format */

import React from "react";
import { Box } from "./MuiCompat";

// Page-wide atmospheric backdrop. Mirrors the deep-blue → violet → sky-cyan
// palette from the hero shader so the whole page reads as one continuous
// world. Fully static — no animation, no canvas, no compositor cost.

const PageBackground: React.FC = () => {
  return (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "var(--color-void-black)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "-15%",
          left: "-10%",
          width: "85vw",
          height: "85vw",
          maxWidth: "1400px",
          maxHeight: "1400px",
          background:
            "radial-gradient(circle at center, rgba(4, 63, 150, 0.85) 0%, rgba(4, 63, 150, 0.3) 35%, rgba(4, 63, 150, 0) 70%)",
          filter: "blur(30px)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "-5%",
          right: "-15%",
          width: "60vw",
          height: "60vw",
          maxWidth: "900px",
          maxHeight: "900px",
          background:
            "radial-gradient(circle at center, rgba(86, 194, 255, 0.32) 0%, rgba(86, 194, 255, 0.08) 40%, rgba(86, 194, 255, 0) 70%)",
          filter: "blur(40px)",
          mixBlendMode: "screen",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: "-15%",
          right: "-10%",
          width: "80vw",
          height: "80vw",
          maxWidth: "1200px",
          maxHeight: "1200px",
          background:
            "radial-gradient(circle at center, rgba(82, 48, 145, 0.7) 0%, rgba(82, 48, 145, 0.22) 40%, rgba(82, 48, 145, 0) 72%)",
          filter: "blur(35px)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: "-20%",
          left: "-15%",
          width: "60vw",
          height: "60vw",
          maxWidth: "900px",
          maxHeight: "900px",
          background:
            "radial-gradient(circle at center, rgba(4, 63, 150, 0.4) 0%, rgba(82, 48, 145, 0.18) 40%, rgba(82, 48, 145, 0) 70%)",
          filter: "blur(45px)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(4, 5, 6, 0) 0%, rgba(4, 5, 6, 0.18) 60%, rgba(4, 5, 6, 0.4) 100%)",
        }}
      />
    </Box>
  );
};

export default PageBackground;
